export const NumericOperation = {
  IN_RANGE: "in_range",
  NOT_IN_RANGE: "not_in_range",
  GREATER_THAN: "greater_than",
  GREATER_THAN_EQUAL: "greater_than_equal",
  LESS_THAN: "less_than",
  LESS_THAN_EQUAL: "less_than_equal",
  EQUAL: "equal",
  NOT_EQUAL: "not_equal",
} as const;
export type NumericOperation = (typeof NumericOperation)[keyof typeof NumericOperation];

export const MultiselectOperation = {
  ANY: "any",
  NOT_ANY: "not_any",
} as const;
export type MultiselectOperation = (typeof MultiselectOperation)[keyof typeof MultiselectOperation];

export const MiscOperation = {
  IS_NOT_NULL: "is_not_null",
  IS_NULL: "is_null",
} as const;
export type MiscOperation = (typeof MiscOperation)[keyof typeof MiscOperation];

type FilterOperation = NumericOperation | MultiselectOperation | MiscOperation;

export const DISPLAY_OPERATION: Record<FilterOperation, string> = {
  [NumericOperation.IN_RANGE]: "is between",
  [NumericOperation.NOT_IN_RANGE]: "is not between",
  [NumericOperation.GREATER_THAN]: "is greater than",
  [NumericOperation.GREATER_THAN_EQUAL]: "is greater than or equal to",
  [NumericOperation.LESS_THAN]: "is less than",
  [NumericOperation.LESS_THAN_EQUAL]: "is less than or equal to",
  [NumericOperation.EQUAL]: "is equal to",
  [NumericOperation.NOT_EQUAL]: "is not equal to",
  [MultiselectOperation.ANY]: "is any of",
  [MultiselectOperation.NOT_ANY]: "is not any of",
  [MiscOperation.IS_NOT_NULL]: "is not null",
  [MiscOperation.IS_NULL]: "is null",
};

export default FilterOperation;
